import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow } from 'ui-components/components/flex';

import { cleanLocationString } from '../helpers';

export const Company = ({ company }) => {
  const cleanCompany = cleanLocationString(company);
  if (!cleanCompany) {
    return null;
  }
  return <FlexRow>{cleanCompany}</FlexRow>;
};

Company.propTypes = {
  company: PropTypes.string,
};
